import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CTASection } from '../components/CTASection';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;
  const fbq = function (...args: unknown[]) {
    if ((fbq as any).callMethod) {
      ;
      (fbq as any).callMethod.apply(fbq, args);
    } else {
      ;
      (fbq as any).queue.push(args);
    }
  } as any;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
  window.fbq('init', '745391951987319');
  window.fbq('track', 'PageView');
}
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  const handleAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        value: 6.36,
        currency: 'USD',
        content_name: 'The Cortisol Reset Kitchen',
        content_type: 'product'
      });
    }
  };
  return <main className="w-full min-h-screen bg-cream font-sans" data-id="element-545" data-mp="243w9vu0hndmb">
      <HeroSection data-id="element-546" data-mp="242cxiehydmpt" />
      <ProblemSection data-id="element-547" data-mp="25ktnqedhft9m" />
      <MechanismSection data-id="element-548" data-mp="25ka6kzvnp8wn" />
      <ProductSection data-id="element-549" data-mp="25m4rwfaub319" />
      <BonusSection data-id="element-550" data-mp="25ll5ala8vqgw" />
      <TestimonialsSection data-id="element-551" data-mp="2ajwhv3rxcf2t" />
      <OfferSection onAddToCart={handleAddToCart} data-id="element-552" data-mp="2ak69evsmauam" />
      <GuaranteeSection data-id="element-553" data-mp="2ahtt0n2icrzo" />
      <CTASection onAddToCart={handleAddToCart} data-id="element-554" data-mp="1vmw0nu7d02il" />
    </main>;
}